import "@/App.css";
import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import Home from "./pages/Home";
import BlogList from "./pages/BlogList";
import BlogPost from "./pages/BlogPost";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";
import PricingPhoto from "./pages/PricingPhoto";
import PricingVideo from "./pages/PricingVideo";
import AGB from "./pages/AGB";
import NotFound from "./pages/NotFound";

function App() {
  const [mounted, setMounted] = useState(false);
  useEffect(() => { setMounted(true); }, []);

  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/blog" element={<BlogList />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/leistungen-preise/immobilienfotografie-preise" element={<PricingPhoto />} />
            <Route path="/leistungen-preise/immobilienvideografie-preise" element={<PricingVideo />} />
            <Route path="/agb" element={<AGB />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            <Route path="/404" element={<NotFound />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Footer />
          <WhatsAppButton />
          {mounted && (
            <Toaster
              position="top-right"
              toastOptions={{
                style: {
                  background: "#1A1A1A",
                  color: "#F8F5EF",
                  border: "1px solid #2A2A2A",
                  borderRadius: "2px",
                  fontFamily: "Outfit, sans-serif",
                },
              }}
            />
          )}
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
